export default {
  title: 'PAGINA PE CARE O CAUȚI TREBUIE SĂ FIE PE UNDEVA...',
  description: 'Cauți una dintre paginile de mai jos?',
  not_found: 'Nu găsim adresa URL introdusă. Te rugăm să verifici dacă a fost introdusă corect.',
  no_restaurants: {
    title: 'Acest magazin nu acceptă încă comenzi online',
    description: 'Revino în curând.',
  },
  toasts: {
    failed_to_load_stores: 'Încărcarea restaurantelor a eșuat, te rugăm să reîmprospătezi pagina',
  },
};
